import gql from 'graphql-tag'

export const DEPARTAMENTO_QUERY = gql`
  query DepartamentoQuery {
    departamentos {
      id
      nome
    }
  }
`
